<template>
    <div class="actAddListDiv" @click="thisClick(actData.actTypeId)">
        <img class="actAddListImg" :src="require(`./../../../../../static/images/${actData.actTypeId}.png`)" width="32" height="32" alt="">
        <span>{{ actData.name }}</span>
    </div>
</template>
<script>
export default {
    // props:['actData'],
    props:{
        actData:{
            type:Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    mounted (){
    },
    methods: {
        thisClick(actTypeId){
            this.$emit('thisClick', actTypeId);
        }
    },
};
</script>
<style lang="less">
    .actAddListDiv{
        cursor: pointer;
    }
    .actAddListImg{
        margin-bottom: 5px;
    }
</style>